import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default from 'react';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppText } from './index-6b88191c.esm.js';
import { View } from 'react-native';
import Slider from 'rc-slider';

const AppTrackSlider = _ref => {
  let {
    style,
    wrapperStyle,
    showValue,
    valueLabel = "",
    value,
    onValueChange,
    unitLabel = "",
    maximumValue,
    minimumValue,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  return /*#__PURE__*/React__default.createElement(View, {
    style: [{
      alignItems: "center"
    }, wrapperStyle]
  }, showValue && /*#__PURE__*/React__default.createElement(AppText, {
    wrapperStyle: {
      marginRight: 5
    }
  }, "".concat(valueLabel, " ").concat(value, " ").concat(unitLabel)), /*#__PURE__*/React__default.createElement(Slider, _extends({
    trackStyle: {
      backgroundColor: currentTheme.theme.primary
    },
    railStyle: {
      backgroundColor: currentTheme.theme.mediumGrey
    }
    // style={[{ width: 200, height: 40 }, style]}
    ,
    value: value,
    onChange: onValueChange,
    max: maximumValue,
    min: minimumValue
  }, props)));
};
AppTrackSlider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppTrackSlider",
  "props": {
    "valueLabel": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Placeholder to append before the value to give a description"
    },
    "unitLabel": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Placeholder to append before the value to give a description"
    },
    "value": {
      "required": true,
      "tsType": {
        "name": "number"
      },
      "description": "Initial value of the slider"
    },
    "onValueChange": {
      "required": true,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(v: any) => void",
        "signature": {
          "arguments": [{
            "name": "v",
            "type": {
              "name": "any"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event fired when value changes"
    },
    "style": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Generic style passed to the core slider component"
    },
    "showValue": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true it shows the value at the top of the slider"
    },
    "wrapperStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Generic style passed to wrapper view of the entire component"
    },
    "maximumValue": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "minimumValue": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    }
  }
};

export { AppTrackSlider as A };
